import { Bleed, Box, Card, Grid, Stack, Stretch } from '@eneco/sparky';

import { LoadingText } from '../../../components/Loading/LoadingText';
import { RoundedSkeleton } from '../../../components/Loading/RoundedSkeleton';

export const ConsumptionGraphicalOverviewSkeleton = () => {
  return (
    <Stretch>
      <Grid
        gridTemplateColumns="repeat(19, 1fr)"
        gridTemplateRows={{ initial: 'auto 1fr', lg: '1fr' }}
        rowGap={6}
        columnGap={{ md: 6 }}>
        <Grid.Item gridColumn={'-1/1'}>
          <Box paddingTop="10">
            <LoadingText height={40} width={280} />
          </Box>
        </Grid.Item>
        <Grid.Item gridColumn={{ initial: '-1/1', lg: '1/14' }}>
          <Stack gap="6">
            <Stack direction="row" alignX="justify" wrap gap={4}>
              <RoundedSkeleton width="40%" height={48} />
              <Stack gap="2" direction="row" wrap>
                <RoundedSkeleton width={160} height={48} />
                <RoundedSkeleton width={160} height={48} />
              </Stack>
            </Stack>
            <Card>
              <Stack>
                <Box padding="4">
                  <RoundedSkeleton width="100%" height={40} />
                </Box>
                <Bleed top="4">
                  <Box padding="4">
                    <RoundedSkeleton width="100%" height={400} />
                  </Box>
                </Bleed>
              </Stack>
            </Card>
          </Stack>
        </Grid.Item>
        <Grid.Item gridColumn={{ initial: '-1/1', lg: '14/19' }}>
          <Stack gap="4">
            <RoundedSkeleton width="100%" height={120} />
            <RoundedSkeleton width="100%" height={80} />
          </Stack>
        </Grid.Item>
      </Grid>
    </Stretch>
  );
};
